module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Devices/Printer-d1723671cb6d7f0a0fa1fdb1ef19d8ee.svg";